import React, { Fragment } from 'react';
import Card from '../../../card/Card';
import GenericHeader from '../../../common/pageHeader/GenericHeader';
import Text from '../../../common/form/Text';
import { configs } from '../../../../constants/configs/configs';
import { useIntl } from 'react-intl';
import { ConditionalRendering } from '../../../common/conditional-rendering';
import { IRenderConsumerSignUpEnabledProps } from '../utils';

const RenderConsumerSignUpEnabled = ({
    path,
    exchangeName,
    isState,
    currentYear,
    landingPageAnonymousTileShow,
}: IRenderConsumerSignUpEnabledProps) => {
    const intl = useIntl();

    return (
        <Fragment>
            <GenericHeader
                id="welcome"
                text="home.landingpage.welcome_header"
                tag="h1"
                headerClassName={['mobile:grid-col-12 tablet:grid-col-fill']}
            />
            <div className="grid-row section__wrapper">
                <div
                    className="desktop:grid-col-12 tablet:grid-col-12 mobile-lg:grid-col-12 grid-col-12 informational__text"
                    data-automation-id="informational-text"
                >
                    <Text
                        {...{
                            id: 'welcome_message',
                            classes: [],
                            text: 'home.landingpage.welcome_message',
                            textReplacements: { exchangeName },
                            display: 'block',
                        }}
                    />
                    <ConditionalRendering isTrue={isState.GA}>
                        <Fragment>
                            <Text
                                {...{
                                    id: 'welcome_message_p2',
                                    text: 'home.landingpage.welcome_message_para_2',
                                    display: 'block',
                                }}
                            />
                        </Fragment>
                    </ConditionalRendering>
                </div>
            </div>

            <GenericHeader
                headerClassName="spl-header-style--01"
                text="home.landingpage.second_header"
                tag="p"
                id="second_header"
            />
            <div className="grid-container padding-0">
                <div className="grid-row padding-0">
                    <ConditionalRendering isTrue={landingPageAnonymousTileShow}>
                        <Card
                            id={{
                                idValue: 'browse_for_health_dental_plans',
                            }}
                            classes={{
                                card: [
                                    'desktop:grid-col-12',
                                    'tablet:grid-col-12',
                                    'mobile-lg:grid-col-12',
                                    'grid-col-12',
                                ],
                                media: ['gi-card__media--doctor'],
                            }}
                            mediaExists={true}
                            contentHeader={{
                                headerId: 'browse_plans',
                                headerClasses: [''],
                                headerText: 'home.landingpage.card1.header',
                                headerDisplay: 'block',
                            }}
                            contentText={{
                                textId: 'browse_plans_msg',
                                textClasses: [''],
                                text: 'home.landingpage.card1.message',
                                display: 'block',
                            }}
                            actions={{
                                cardRedirect: path,
                                isExternal: true,
                            }}
                        />
                    </ConditionalRendering>
                    <Card
                        id={{
                            idValue: 'register_with_access_code',
                        }}
                        classes={{
                            card: ['desktop:grid-col-12', 'tablet:grid-col-12', 'mobile-lg:grid-col-12', 'grid-col-12'],
                            media: ['gi-card__media--family'],
                        }}
                        mediaExists={true}
                        contentHeader={{
                            headerId: 'access_code',
                            headerClasses: [''],
                            headerText: 'home.landingpage.card2.header',
                            headerDisplay: 'block',
                        }}
                        contentText={{
                            textId: 'access_code_msg',
                            textClasses: [''],
                            text: 'home.landingpage.card2.message',
                            textReplacements: { currentYear },
                            display: 'block',
                        }}
                        actions={{
                            cardRedirect: configs.routes.ACCESS_CODE,
                            isExternal: false,
                        }}
                    />
                    <Card
                        id={{
                            idValue: 'login_to_existing_account',
                        }}
                        classes={{
                            card: ['desktop:grid-col-12', 'tablet:grid-col-12', 'mobile-lg:grid-col-12', 'grid-col-12'],
                            media: ['gi-card__media--auth'],
                        }}
                        mediaExists={true}
                        contentHeader={{
                            headerId: 'login',
                            headerClasses: [''],
                            headerText: 'home.landingpage.card3.header',
                            headerDisplay: 'block',
                        }}
                        contentText={{
                            textId: 'login_msg',
                            textClasses: [''],
                            text: 'home.landingpage.card3.message',
                            display: 'block',
                        }}
                        actions={{
                            cardRedirect: configs.endpoints.ACCOUNT_LOGIN,
                            isExternal: true,
                        }}
                        gtm={{
                            gtmValue: intl.formatMessage({ id: 'home.landingpage.card3.header' }),
                        }}
                    />
                </div>
            </div>
        </Fragment>
    );
};

export default RenderConsumerSignUpEnabled;
